
import { computed, defineComponent, ref } from 'vue';
// import { useRouter } from 'vue-router';
import {
  ICaseFilesManage,
  ICase, IFileUpload, ISearchLabelInput,
} from '@/types/interfaces';
import AppSoloCaseSelector from '@/components/AppSoloCaseSelector.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import { useMainStore } from '@/store/mainStore';
import UseUpload from '@/composables/UseUpload';
import UploadService from '@/services/UploadService';
import AppUploadInfo from '@/components/UI/AppUploadInfo.vue';
import { UPLOAD_PLACES } from '@/types/enums';
import { useDriveStore } from '@/modules/drive/store/driveStore';

export default defineComponent({
  emits: ['close'],
  components: {
    AppLoader,
    AppSoloCaseSelector,
    AppUploadInfo,
  },
  props: {
    fileToUpload: { type: Array as () => IFileUpload[], required: true },
    labels: { type: Array as () => ISearchLabelInput[], default: [] as ISearchLabelInput[] },
  },
  setup(props, { emit }) {
    const mainStore = useMainStore();
    const driveStore = useDriveStore();
    const isShow = ref(false);
    const isLoading = ref(false);
    // const router = useRouter();

    const { uploadInfo, onUploadUpdate } = UseUpload();

    const loaderText = computed(() => '');

    function onCancel() {
      isShow.value = false;
    }

    function cancelUpload() {
      UploadService.isAbortUpload = true;
      isLoading.value = false;
    }

    function handleSelect(item: ICase) {
      // isLoading.value = true;

      const { id } = item;
      UploadService.batchUploadTUS(props.fileToUpload, onUploadUpdate, { location: UPLOAD_PLACES.CASE_PHOTO, id: id! }, undefined, props.labels, true)
        .then((files) => {
          const filesPayload = {
            id,
            fileIds: files.map((file) => file.id),
          } as ICaseFilesManage;

          driveStore.addFilesToCase(filesPayload);
        });

      // .then((response: IResponse<null>) => {
      //   if (response?.success) {
      //     const caseId = item.id;
      //     router.push(`/drive/case/my/${(caseId as string)}/view`);
      //     mainStore.BottomPopUpType = null;
      //   }
      // }).finally(() => {
      //   isLoading.value = false;
      // });

      isShow.value = false;
      mainStore.BottomPopUpType = null;
      emit('close');
    }

    return {
      isShow,
      isLoading,
      loaderText,
      uploadInfo,
      onCancel,
      handleSelect,
      cancelUpload,
    };
  },
});
